// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"473":"ac388f5a","684":"a915c8d2","948":"21861c3c","978":"0000c50d"}[chunkId] + ".chunk.css";
};